// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__XVD0j","topBottomGutter":"Layout_topBottomGutter__fFRjA"};